export const letterFields = {
  Letter: [
    {
      id: "letterheadCode",
      label: "Letterhead Code",
      type: "text",
      placeholder: "Letterhead Code",
      name: "letterhead_code",
    },
    {
      id: "recipientName",
      label: "Recipient Name",
      type: "text",
      placeholder: "Recipient Name",
      name: "recipient_name",
      updateContent: true,
    },
    {
      id: "address",
      label: "Recipient Address",
      type: "text",
      placeholder: "Recipient Address",
      name: "address",
    },
    {
      id: "date",
      label: "Date",
      type: "date",
      placeholder: "Date",
      name: "date",
    },
    {
      id: "subject",
      label: "Subject",
      type: "text",
      placeholder: "Subject",
      name: "subject",
    },
    {
      id: "signature",
      label: "Signature",
      type: "text",
      placeholder: "Signature (Your Name, Designation)",
      name: "signature",
    },
  ],
  "Offer Letter": [
    {
      id: "letterheadCode",
      label: "Letterhead Code",
      type: "text",
      placeholder: "Letterhead Code",
      name: "letterhead_code",
    },
    {
      id: "title",
      label: "Title",
      type: "select",
      name: "title",
      options: [
        { value: "", label: "Select Title" },
        { value: "Mr", label: "Mr" },
        { value: "Mrs", label: "Mrs" },
        { value: "Miss", label: "Miss" },
      ],
      updateContent: true,
    },
    {
      id: "recipientName",
      label: "Recipient Name",
      type: "text",
      placeholder: "Recipient Name",
      name: "recipient_name",
      updateContent: true,
    },
    {
      id: "mobileNumber",
      label: "Mobile Number",
      type: "tel",
      placeholder: "Mobile Number",
      name: "mobile_number",
      updateContent: true,
    },
    {
      id: "email",
      label: "Email",
      type: "email",
      placeholder: "Email",
      name: "email",
      updateContent: true,
    },
    {
      id: "position",
      label: "Position",
      type: "text",
      placeholder: "Position",
      name: "position",
      updateContent: true,
    },
    {
      id: "annualSalary",
      label: "Annual Salary",
      type: "text",
      placeholder: "Annual Salary (e.g., 500000)",
      name: "annual_salary",
      updateContent: true,
    },
    {
      id: "dateOfAppointment",
      label: "Date of Appointment",
      type: "date",
      placeholder: "Date of Appointment",
      name: "date_of_appointment",
      updateContent: true,
    },
    {
      id: "address",
      label: "Recipient Address",
      type: "text",
      placeholder: "Recipient Address",
      name: "address",
    },
    {
      id: "date",
      label: "Date",
      type: "date",
      placeholder: "Date",
      name: "date",
    },
    {
      id: "subject",
      label: "Subject",
      type: "text",
      placeholder: "Subject",
      name: "subject",
    },
    {
      id: "signature",
      label: "Signature",
      type: "text",
      placeholder: "Signature (Your Name, Designation)",
      name: "signature",
    },
  ],
  "Bank Details": [
    {
      id: "letterheadCode",
      label: "Letterhead Code",
      type: "text",
      placeholder: "Letterhead Code",
      name: "letterhead_code",
    },
    {
      id: "title",
      label: "Title",
      type: "select",
      name: "title",
      options: [
        { value: "", label: "Select Title" },
        { value: "Mr", label: "Mr" },
        { value: "Mrs", label: "Mrs" },
        { value: "Miss", label: "Miss" },
      ],
      updateContent: true,
    },
    {
      id: "recipientName",
      label: "Recipient Name",
      type: "text",
      placeholder: "Recipient Name",
      name: "recipient_name",
      updateContent: true,
    },
    {
      id: "place",
      label: "Place",
      type: "text",
      placeholder: "Place",
      name: "place",
      updateContent: true,
    },
    {
      id: "position",
      label: "Position",
      type: "text",
      placeholder: "Position",
      name: "position",
      updateContent: true,
    },
    {
      id: "dateOfAppointment",
      label: "Date of Joining",
      type: "date",
      placeholder: "Date of Joining",
      name: "date_of_appointment",
      updateContent: true,
    },
    {
      id: "address",
      label: "Recipient Address",
      type: "text",
      placeholder: "Recipient Address",
      name: "address",
    },
    {
      id: "date",
      label: "Date",
      type: "date",
      placeholder: "Date",
      name: "date",
      updateContent: true,
    },
    {
      id: "subject",
      label: "Subject",
      type: "text",
      placeholder: "Subject",
      name: "subject",
    },
    {
      id: "signature",
      label: "Signature",
      type: "text",
      placeholder: "Signature (Your Name, Designation)",
      name: "signature",
    },
  ],
  "Bank Details Request Letter": [
  {
    id: "letterheadCode",
    label: "Letterhead Code",
    type: "text",
    placeholder: "Letterhead Code",
    name: "letterhead_code",
  },
  {
    id: "title",
    label: "Title",
    type: "select",
    name: "title",
    options: [
      { value: "", label: "Select Title" },
      { value: "Mr", label: "Mr" },
      { value: "Mrs", label: "Mrs" },
      { value: "Miss", label: "Miss" },
    ],
    updateContent: true,
  },
  {
    id: "recipientName",
    label: "Recipient Name",
    type: "text",
    placeholder: "Recipient Name",
    name: "recipient_name",
    updateContent: true,
  },
  {
    id: "employeeName",
    label: "Employee Name",
    type: "text",
    placeholder: "Employee Name",
    name: "employee_name",
    updateContent: true,
  },
  {
    id: "employeeId",
    label: "Employee ID",
    type: "text",
    placeholder: "Employee ID",
    name: "employee_id",
    updateContent: true,
  },
  {
    id: "dateOfBirth",
    label: "Date of Birth",
    type: "date",
    placeholder: "Date of Birth",
    name: "date_of_birth",
    updateContent: true,
  },
  {
    id: "contactNumber",
    label: "Contact Number",
    type: "tel",
    placeholder: "Contact Number",
    name: "contact_number",
    updateContent: true,
  },
  {
    id: "residentialAddress",
    label: "Residential Address",
    type: "text",
    placeholder: "Residential Address",
    name: "residential_address",
    updateContent: true,
  },
  
  {
    id: "position",
    label: "Position",
    type: "text",
    placeholder: "Position",
    name: "position",
    updateContent: true,
  },
  {
    id: "dateOfAppointment",
    label: "Date of Joining",
    type: "date",
    placeholder: "Date of Joining",
    name: "date_of_appointment",
    updateContent: true,
  },
  {
    id: "address",
    label: "Bank Address",
    type: "text",
    placeholder: "Enter bank Address",
    name: "address",
  },
  {
    id: "date",
    label: "Date",
    type: "date",
    placeholder: "Date",
    name: "date",
    updateContent: true,
  },
  {
    id: "subject",
    label: "Subject",
    type: "text",
    placeholder: "Subject",
    name: "subject",
  },
  {
    id: "signature",
    label: "Signature",
    type: "text",
    placeholder: "Signature (Your Name, Designation)",
    name: "signature",
  },
],
  "Relieving Letter": [
    {
      id: "letterheadCode",
      label: "Letterhead Code",
      type: "text",
      placeholder: "Letterhead Code",
      name: "letterhead_code",
    },
    {
      id: "recipientName",
      label: "Recipient Name",
      type: "text",
      placeholder: "Recipient Name",
      name: "recipient_name",
      updateContent: true,
    },
    {
      id: "employeeName",
      label: "Employee Name",
      type: "text",
      placeholder: "Employee Name",
      name: "employee_name",
      updateContent: true,
    },
    {
      id: "position",
      label: "Position",
      type: "text",
      placeholder: "Position",
      name: "position",
      updateContent: true,
    },
    {
      id: "effectiveDate",
      label: "Effective Date",
      type: "date",
      placeholder: "Effective Date",
      name: "effective_date",
      updateContent: true,
    },
    {
      id: "address",
      label: "Recipient Address",
      type: "text",
      placeholder: "Recipient Address",
      name: "address",
    },
    {
      id: "date",
      label: "Date",
      type: "date",
      placeholder: "Date",
      name: "date",
    },
    {
      id: "subject",
      label: "Subject",
      type: "text",
      placeholder: "Subject",
      name: "subject",
    },
    {
      id: "signature",
      label: "Signature",
      type: "text",
      placeholder: "Signature (Your Name, Designation)",
      name: "signature",
    },
  ],
};